import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { Button, Space, Row, Col, Typography, Card, Table } from 'antd'
import { ActionButton, ActivityLogModal, AlertModal, FileEditModal, ModuleTopHeading } from '../../components'
import { actionsApi, ApiCalls, TableLoader, timeDifference, utcToLocal } from '../../shared'
import { DeleteOutlined, EditOutlined, FileOutlined, OrderedListOutlined} from '@ant-design/icons'
import { ActivityLogDrawer, AddEditBoxDrawer, Filter, ImportDevices, ViewPortalsModal } from '../../components/BoxManagement'
import { methodAllow } from '../../shared/lookups';
import { useTranslation } from 'react-i18next';  // i18n import

const { Text } = Typography
const PING_INTERVAL = 30000; // Ping every 30 seconds

const BoxManagement = () => {
    
    const dispatch = useDispatch()
    const { t } = useTranslation()  // i18n hook
    
    const { data, loading, filters, pagination } = useSelector(state => state?.addEditBox)
    const [visible, setVisible]= useState(false)
    const [visibleDeleteModal, setVisibleDeleteModal] = useState(false);
    const [ editbox, setEditBox ] = useState(null)
    const [ visiblelog, setVisibleLog ] = useState(false)
    const [visibleActivityLogDrawer, setVisibleActivityLogDrawer]= useState(false)
    const [visibleViewPortalsModal, setVisibleViewPortalsModal]= useState(false)
    const [ editmodal, setEditModal ] = useState(false)
    const [ deletebox, setDeleteBox ] = useState()
    const {userData}= useSelector(state => state?.login)

    useEffect(()=>{
        let intervalId
        if(data?.length){
        //    intervalId = setInterval(()=>{boxesStatusCall(pagination?.pageNo, pagination?.pageSize)}, PING_INTERVAL);
        }
        else
            clearInterval(intervalId)
        return () => clearInterval(intervalId)
    }, [data])

    const boxesStatusCall= (pageNo=1, pageSize=10)=>{
        dispatch(actionsApi?.getBoxesStatus({ ...filters, pageNo, pageSize }))
    }
    const call = (pageNo = 1, pageSize = 10) => {
        let newFilters = { ...filters, pageNo, pageSize };
        if (userData?.role === 'masterAdmin' && filters?.masterVendorId) {
            newFilters = { ...newFilters, userID: filters.masterVendorId };
        }
        dispatch(actionsApi?.viewAllAndroidBoxes(newFilters));
    }  

    const columns = [
        {
            title: <Text>{t("Serial #")}</Text>,
            dataIndex: 'serialNo',
            key: 'serialNo',
            width: '200px'
        },
        {
            title: <Text>{t("Box Name")}</Text>,
            dataIndex: 'boxName',
            key: 'boxName',
            fixed:'left',
            width:180,
        },
        {
            title: <Text>{t("Customer Name")}</Text>,
            dataIndex: 'customerName',
            key: 'customerName',
            fixed:'left',
            width:180,
        },
        {
            title: <Text>{t("Mac Address")}</Text>,
            dataIndex: 'macAddress',
            key: 'macAddress',
            render: col => (<Text className='brand-color'>{col}</Text>)
        },
        {
            title: <Text>{(userData?.role==='masterAdmin') ? t('Master Vendor') : t('Vendor User')}</Text>,
            dataIndex:userData?.role==='masterAdmin'? 'vendorName':userData?.role==='masterVendor'?'addedByName':'addedByName',
            key: userData?.role==='masterAdmin'? 'vendorName':userData?.role==='masterVendor'?'addedByName':'addedByName',
        },
        {
            title: <Text>{t("Url Update")}</Text>,
            dataIndex: 'updateUrl',
            key: 'updateUrl',
            render: col => <Text>{methodAllow?.find(fin => fin?.id === parseInt(col))?.name || '-'}</Text>
        },
        {
            title: <Text>{t("Status")}</Text>,
            dataIndex: 'status',
            key: 'status',
            render: (_, row) => {
                return (
                    !row?.dateTime || (row?.dateTime && (timeDifference(utcToLocal(row?.dateTime)) > 60000)) ? 
                    <Space>
                        <img src="/assets/icons/offline.png" width={'12px'} alt="" />
                        <Text style={{transform:"translateY(-2px)",display:'block'}}>{t('offline')}</Text>
                    </Space>
                    :
                    <Space align='center'>
                        <img src="/assets/icons/online.png" width={'12px'} alt="" />
                        <Text style={{transform:"translateY(-2px)",display:'block'}}>{t('online')}</Text>
                    </Space>
                );
            }
        },
        {
            title: <Text>{t("Last seen")}</Text>,
            dataIndex: 'dateTime',
            key: 'dateTime',
            render: dateTime => utcToLocal(dateTime)
        },
        {
            title: <Text>{t("Action")}</Text>,
            key: 'action',
            fixed:'right',
            width: 120,
            render: (_, row) => (
                <Space>
                    <ActionButton
                        title={t('View Portals')}
                        className='btn-color-green'
                        type='primary'
                        icon={<OrderedListOutlined />}
                        onClick={()=> {
                            setVisibleViewPortalsModal(row?.macAddress)
                            dispatch(actionsApi?.getPortals(row?.id))
                        }}
                    />
                    <ActionButton
                        title={t('Edit Box')}
                        icon={<EditOutlined className='green-color'/>}
                        onClick={()=>{setVisible(true);setEditBox(row?.id)}}
                    />
                    <ActionButton
                        title={t('Delete Box')}
                        icon={<DeleteOutlined className='danger-color'/>}
                        onClick={()=>{setVisibleDeleteModal(true);setDeleteBox({id:row?.id, name: row?.boxName})}}
                        danger
                    />
                </Space>
            ),
        }
    ]
    const removeRow= async (ID)=>{
        const result = await ApiCalls?.AddEditBoxApi?.DeleteAndroidApi(ID)
        if(result)
            return 1
        return 0
    }


  return (
    <div>
        <Card className='radius-12 border0'>
            <Row gutter={[12,12]}>
                <Col span={24}>
                    <div className='space-between-center'>
                        <ModuleTopHeading
                            name={t('Box Management My Enjoy Tv')}
                            onClick={()=>{setVisible(true)}}
                        />
                        <Button
                            type='primary'
                            icon={<FileOutlined />}
                            onClick={()=> setVisibleActivityLogDrawer(true)}
                            className='btn-color-other translate-down'
                        >
                            {t('Activity log')}
                        </Button>
                    </div>
                </Col>
                <Col span={24}>
                    <Filter/>
                </Col>
                <Col span={24}>
                    <Table 
                        size='large'
                        columns={columns} 
                        dataSource={data} 
                        className='table-cover'
                        scroll={{x: 1500}}
                        pagination={{
                            hideOnSinglePage: true,
                            total: pagination?.totalRecords,
                            pageSize: pagination?.pageSize,
                            defaultPageSize: pagination?.pageSize,
                            current: pagination?.pageNo,
                            size: "default",
                            pageSizeOptions: ['10', '20', '50', '100'],
                            onChange: (pageNo, pageSize) => call(pageNo, pageSize),
                            showTotal: (total) => <Button>{t('Total')}: {total}</Button>,
                        }}
                        loading={
                            {
                                ...TableLoader,
                                spinning: loading
                            }
                        }
                    />
                </Col>
            </Row>
        </Card>
        <ImportDevices />
        <ActivityLogDrawer 
            visible={visibleActivityLogDrawer} 
            onClose={()=> setVisibleActivityLogDrawer(false)}
        />
        <ViewPortalsModal
            visible={visibleViewPortalsModal}
            onClose={()=> {
                dispatch(actionsApi?.clearPortalsResponse())
                setVisibleViewPortalsModal(false)
            }}
        />
        <AddEditBoxDrawer
            visible={visible}
            editbox={editbox}
            getAllApplications={call}
            onClose={()=> {setVisible(false);setEditBox(null)}}
        />
        <ActivityLogModal 
            visiblelog = {visiblelog}
            onClose={()=>setVisibleLog(false)}
        />
        <FileEditModal 
            editmodal={editmodal}
            onClose={()=>setEditModal(false)}
        />
        <AlertModal
            visible={visibleDeleteModal}
            row={deletebox}
            removeRow={removeRow}
            endCall={call}
            onClose={()=>{setVisibleDeleteModal(false);setDeleteBox(null)}}
        />
    </div>
  )
}

export {BoxManagement}
